import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../theme/Component/BasicPage";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import { _AddPayment, _CalendarValues, _GetProjectInfo, _PaymentTurn, _ProjectInfo } from "../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { ProjectSelectEditor } from "../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { InputDate } from "../../theme/Input/InputDate";
import { ConceptByProcessTypeSelect } from "./ConceptByProcessTypeSelect";
import { BasicButton } from "../../theme/Component/BasicButton";
import { DataCatalog } from "./DataCatalog";




export const ProjectInfo = () => {

    const ProjectInfo = useDataBean(_ProjectInfo);
    const getvalues = useDataBean(_CalendarValues);
    const [state, setState] = useState<any>(null)
    const [tableName, settableName] = useState<any>(null)
    const [documentsTable, setdocumentsTable] = useState<any>(null)
    const [modalverdoc, setModalverdoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [lista, setLista] = useState<any>([]);


    useEffect(() => {
        getActualCalendarValues();
    }, [])

    const createProjectDataTable = () => {

        ProjectInfo.instance.createProjectDataTable(ProjectInfo.bean.IDAccountantConcept, ProjectInfo.bean.IDProject, ProjectInfo.bean.FromDate, ProjectInfo.bean.UptoDate).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Consulta Generada');
                    setState('true')
                    const id = resp.ProjectDataTableName; // ✅ Aquí obtienes el ID
                    console.log("ProjectDataTableName:", id); // 👈 Aquí lo ves en consola}
                    settableName(id)
                    const doc = resp.DocumentsTable;
                    setdocumentsTable(doc)
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const getActualCalendarValues = () => {


        getvalues.instance.getActualCalendarValues(null).then(
            (resp: any) => {
                if (resp) {

                    const dateone = resp.FromDate;
                    const datetwo = resp.UptoDate;

                    ProjectInfo.setBean({
                        ...ProjectInfo.bean,
                        FromDate: dateone || ProjectInfo.bean.FromDate,  // Usa el valor del backend si existe
                        UptoDate: datetwo || ProjectInfo.bean.UptoDate   // Usa el valor del backend si existe
                    });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }



    return (
        <BasicPage titulo="Informe Financiero de Proyectos">
            <>
                <div className="row">
                    <div className="col-md-6">
                        <ConceptByProcessTypeSelect idSelector={ProjectInfo.bean.IDAccountantConcept} onChange={(e: any) => { ProjectInfo.setBean({ ...ProjectInfo.bean, "IDAccountantConcept": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Proyecto</label>
                        <ProjectSelectEditor render={ProjectInfo.bean.ProjectName} idSelector={ProjectInfo.bean.IDProject} onChange={(e) => { ProjectInfo.setBean({ ...ProjectInfo.bean, "IDProject": e.IDProject, "ProjectName": e.Name }) }} label=" " returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="FromDate" label="Fecha Inicial" value={ProjectInfo.bean.FromDate} setDate={(e: any) => { ProjectInfo.setBean({ ...ProjectInfo.bean, "FromDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="UptoDate" label="Fecha Final" value={ProjectInfo.bean.UptoDate} setDate={(e: any) => { ProjectInfo.setBean({ ...ProjectInfo.bean, "UptoDate": e }) }} />
                    </div>
                    <div className="col-md-6 mt-4">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={createProjectDataTable}>
                            Generar Consulta
                        </BasicButton>
                    </div>
                    {state && <>
                        <div className="row">


                            <div className="col-md-12">
                                <DataCatalog tableName={tableName} documentsTable={documentsTable} />
                            </div>
                        </div>


                    </>}

                </div>
            </>
        </BasicPage>
    )
}